import React, { useState, useEffect } from 'react';
import $i18n from '../../../../i18n';
import Requests from '@/services/request';
import { Select } from '@b-design/fusion';
import { TimeSelectOptions, ChartTitleTypes } from './const';
import GraphicComponent from './graphicComponent';
import { getQueryStringArgs } from '@/utils/url-parse';
import './index.less';

const MonitoringDashboard: React.FC = () => {
  const { spaceId } = getQueryStringArgs();
  const [durationData, setDurationData] = useState([]); // 消耗时长-数据
  const [durationTimeType, setDurationTimeType] = useState('thisMonth'); // 消耗时长-时间
  const [frequencyData, setFrequencyData] = useState([]); // 消耗次数-数据
  const [frequencyTimeType, setFrequencyTimeType] = useState('thisMonth'); // 消耗次数-时间

  const ChartList = [
    {
      cardType: 'duration',
      cardTitle: $i18n.get({
        id: 'aopf.component.monitoringDashboard.ConsumptionDurationMonitoring',
        dm: '消耗时长监控',
      }),
      chartTitle: $i18n.get(
        {
          id: 'aopf.component.monitoringDashboard.CharttitletypesdurationtimetypeConsumptionDurationHours',
          dm: '{ChartTitleTypesDurationTimeType}消耗时长（小时）',
        },
        { ChartTitleTypesDurationTimeType: ChartTitleTypes[durationTimeType] },
      ),
      seriesName: $i18n.get({
        id: 'aopf.component.monitoringDashboard.ConsumptionDuration',
        dm: '消耗时长',
      }),
      uint: $i18n.get({ id: 'aopf.component.monitoringDashboard.Hours', dm: '小时' }),
      timeValue: durationTimeType,
      onChange: setDurationTimeType,
      data: durationData,
      dataKey: 'duration',
    },
    {
      cardType: 'frequency',
      cardTitle: $i18n.get({
        id: 'aopf.component.monitoringDashboard.ConsumptionMonitoring',
        dm: '消耗次数监控',
      }),
      chartTitle: $i18n.get(
        {
          id: 'aopf.component.monitoringDashboard.CharttitletypesdurationtimetypeConsumptionTimesTimes',
          dm: '{ChartTitleTypesDurationTimeType}消耗次数（次）',
        },
        { ChartTitleTypesDurationTimeType: ChartTitleTypes[frequencyTimeType] },
      ),
      seriesName: $i18n.get({
        id: 'aopf.component.monitoringDashboard.ConsumptionTimes',
        dm: '消耗次数',
      }),
      uint: $i18n.get({ id: 'aopf.component.monitoringDashboard.Times', dm: '次' }),
      timeValue: frequencyTimeType,
      onChange: setFrequencyTimeType,
      data: frequencyData,
      dataKey: 'number',
    },
  ];

  const renderCard = ({
    cardType,
    cardTitle,
    chartTitle,
    seriesName,
    uint,
    timeValue,
    onChange,
    data,
    dataKey,
  }) => {
    return (
      <div className="dashboard-card" key={cardType}>
        <div className="card-header">
          <span className="title">{cardTitle}</span>
          <Select
            dataSource={TimeSelectOptions}
            value={timeValue}
            onChange={(value) => onChange(value)}
          />
        </div>
        <GraphicComponent
          data={data || []}
          chartTitle={chartTitle}
          seriesName={seriesName}
          uint={uint}
          dataKey={dataKey}
          timeType={cardType === 'duration' ? durationTimeType : frequencyTimeType}
        />
      </div>
    );
  };

  useEffect(() => {
    Requests.get('/rest/intercnn/aigc/monitor/duration', {
      spaceId: spaceId,
      type: durationTimeType,
    })
      .then((data) => {
        setDurationData(data || []);
      })
      .catch(() => {
        setDurationData([]);
      });
  }, [durationTimeType]);

  useEffect(() => {
    Requests.get('/rest/intercnn/aigc/monitor/number', {
      spaceId: spaceId,
      type: frequencyTimeType,
    })
      .then((data) => {
        setFrequencyData(data || []);
      })
      .catch(() => {
        setFrequencyData([]);
      });
  }, [frequencyTimeType]);

  return <div className="monitoring-dashboard">{ChartList.map((v) => renderCard(v))}</div>;
};

export default MonitoringDashboard;
